import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import {
  PlaylistModel,
  PlaylistReqModel,
  PlaylistScreenOption
} from '@modules/digital-signage/model/playlists.model.ts';

export interface PlaylistsParams {
  ids: string[];
  state?: any;
  handleClose?: () => void;
}

export interface CreatePlaylistParams {
  body: PlaylistReqModel;
  state?: any;
  handleClose?: () => void;
}

export interface EditPlaylistParams {
  id: string;
  body: PlaylistReqModel;
  state?: any;
  handleClose?: () => void;
}

export interface PlaylistsState extends CallStateMethods {
  callState: CallStateEnum;
  screensData: PlaylistScreenOption[];
  getScreens: () => void;
  deleteRow: (params: PlaylistsParams) => void;
  createPlaylist: (
    params: CreatePlaylistParams
  ) => Promise<PlaylistModel | undefined>;
  editPlaylist: (params: EditPlaylistParams) => void;
}

interface PlaylistsStateMethods extends CallStateMethodNames {
  screensData: 'screensData';
  getScreens: 'getScreens';
  deleteRow: 'deleteRow';
  createPlaylist: 'createPlaylist';
  editPlaylist: 'editPlaylist';
}

export const PLAYLISTS_INITIAL_STATE: Omit<
  PlaylistsStateMethods,
  keyof PlaylistsState
> = {
  callState: CallStateEnum.Init,
  screensData: []
};
